export default {
  primary: '#4caf50',
  secondary: '#1b5e20',
  success: '#c8e6c9',
  warning: '#1b5e20',
  info: '#a7ffeb',
  error: '#004d40',
  track: '#00bfa5'
};